(function ($) {
	class W4D_Instashop1 {
		constructor() {
			this.instances = new Map();
			this.initSelectors();
			this.initInstances();
			this.bindEvents();
		}

		initSelectors() {
			this.configSelector = '.w4d-instashop-config';
			this.containerSelector = '.instashop-1[data-block-id]';
			// open trigger is now a native command button
			this.openSelector = '[commandfor^="instashop-1-"][command="show-modal"][data-card-id]';
			this.prevArrowSelector = '[data-js-instashop-prev]';
			this.nextArrowSelector = '[data-js-instashop-next]';
			// dialog now identified by id, not data-modal
			this.dialogSelector = 'dialog[id^="instashop-1-"]';
			this.productsScrollSelector = '.instashop-1-modal__products';
		}

		initInstances() {
			$(this.configSelector).each((_, el) => {
				const blockId = el.dataset.blockId;
				const json = el.textContent.trim();

				if (!blockId || !json) {
					console.warn('Missing blockId or json, skipping');
					return;
				}

				try {
					const cardsData = JSON.parse(json);

					const $root = $(`.instashop-1[data-block-id="${blockId}"]`);

					this.instances.set(String(blockId), {
						$el: $root,
						cardsData,
						currentIndex: 0,
					});
				} catch (err) {
					console.error('Instashop1 JSON parse failed for block:', blockId, err);
				}
			});
		}

		bindEvents() {
			// Open click - bind na container da se izvrši PRIJE DialogManager
			$(this.containerSelector).each((_, el) => {
				const $container = $(el);
				$container.on('click', this.openSelector, (e) => this.handleOpenClick(e));
			});

			$(document).on('click', `${this.prevArrowSelector}, ${this.nextArrowSelector}`, (e) => this.handleArrowClick(e));
		}

		handleOpenClick(e) {
			const $trigger = $(e.currentTarget);
			const modalId = $trigger.attr('commandfor');
			const cardIndex = parseInt($trigger.attr('data-card-id'), 10);

			if (!modalId || Number.isNaN(cardIndex)) {
				console.error('Invalid modalId or cardIndex, aborting');
				return;
			}

			const blockId = String(modalId.replace('instashop-1-', ''));
			const instance = this.instances.get(blockId);

			if (!instance) {
				console.error('No instance for blockId:', blockId);
				console.info('Available instances:', Array.from(this.instances.keys()));
				return;
			}

			instance.currentIndex = cardIndex;
			this.populateDialog(blockId, cardIndex);
		}

		handleArrowClick(e) {
			e.preventDefault();
			e.stopPropagation();

			const $arrow = $(e.currentTarget);
			const $dialog = $arrow.closest('dialog[open]');
			const modalId = $dialog.attr('id');

			if (!modalId) {
				console.error('No open dialog found');
				return;
			}

			const blockId = String(modalId.replace('instashop-1-', ''));
			const direction = $arrow.attr('data-js-instashop-prev') !== undefined ? 'prev' : 'next';

			this.navigate(blockId, direction);
		}

		navigate(blockId, direction) {
			const instance = this.instances.get(String(blockId));
			if (!instance || !instance.cardsData || instance.cardsData.length <= 1) {
				console.error('Navigation not possible:', {
					hasInstance: !!instance,
					hasCards: !!instance?.cardsData,
					cardsLength: instance?.cardsData?.length,
				});
				return;
			}

			const max = instance.cardsData.length - 1;
			const current = instance.currentIndex ?? 0;

			let nextIndex;
			if (direction === 'prev') {
				nextIndex = current > 0 ? current - 1 : max;
			} else {
				nextIndex = current < max ? current + 1 : 0;
			}

			instance.currentIndex = nextIndex;
			this.populateDialog(blockId, nextIndex);
		}

		populateDialog(blockId, cardIndex) {
			const instance = this.instances.get(String(blockId));
			const card = instance?.cardsData?.[cardIndex];

			if (!card) {
				console.error('No card data for:', { blockId, cardIndex });
				return;
			}

			const modalId = `instashop-1-${blockId}`;
			const $dialog = $(`dialog[id="${modalId}"]`);

			if (!$dialog.length) {
				console.error('Dialog not found:', modalId);
				return;
			}

			// Update content
			const $img = $dialog.find('[data-instashop-img]');
			const $title = $dialog.find('[data-instashop-title]');
			const $products = $dialog.find('[data-instashop-products]');
			const $productsWrapper = $dialog.find('[data-instashop-products-wrapper]');

			$img.attr('src', card.img_src || '').attr('alt', card.gallery_title || '');
			$title.text(card.gallery_title || '');
			$products.html(card.products_html || '');

			// 2) NOW call blur init (because markup exists now)
			if (window.W4D_CarouselInstance) {
				window.W4D_CarouselInstance.init();
			}

			if (window.W4D_ShopCategories) {
				window.W4D_ShopCategories.reinit($productsWrapper);
			}

			if (card.products_html) {
				$productsWrapper.removeClass('instashop-1-modal__products-wrapper--no-products');
			} else {
				$productsWrapper.addClass('instashop-1-modal__products-wrapper--no-products');
			}

			this.resetProductsScroll($dialog);
		}

		resetProductsScroll($dialog) {
			const $products = $dialog.find(this.productsScrollSelector);
			if ($products.length) {
				$products.scrollTop(0);
			}
		}
	}

	$(document).ready(function () {
		new W4D_Instashop1();
	});
})(jQuery);
